module.exports = __webpack_public_path__ + "img/checkbox-round.0f0e7967.svg";